import { computed, makeObservable } from 'mobx';
import { UserType } from '../../API/resources/users';

interface UserModelOptions {
  id: number;
  secondName?: string;
  username: string;
  firstName?: string;
  lastName?: string;
  isSuperUser: boolean;
  userType: UserType;
}

interface IUserModel {
  display: string;
}

export class UserModel implements IUserModel {
  id: number;
  secondName?: string;
  username: string;
  firstName?: string;
  lastName?: string;
  isSuperUser: boolean;
  userType: UserType;

  constructor(options: UserModelOptions) {
    this.id = options.id;
    this.firstName = options.firstName;
    this.secondName = options.secondName;
    this.lastName = options.lastName;
    this.username = options.username;
    this.isSuperUser = options.isSuperUser;
    this.userType = options.userType;

    makeObservable(this);
  }

  @computed get display(): string {
    if (this.lastName && this.firstName) {
      return `${this.lastName} ${this.firstName}`;
    }

    return this.username;
  }
}
